// extracted by mini-css-extract-plugin
module.exports = {"user":"MemberRow-module_user__WAtH_ryofKI6lHJtHXs2","userName":"MemberRow-module_userName__mXeSbggWmvCKSTvA53Y0","groupImage":"MemberRow-module_groupImage__y4Nl5lsW8gjgOGOQnKr0"};